import React from 'react';
import {Box, Typography, Alert} from '@mui/material';
import {isNotNil} from '@practicegenius/pg-util/src/TypescriptUtils';
import {Button, ButtonVariant} from '../base/Material/components/Button';

type Props = {
  retryFn?: () => void;
  messageBody?: React.ReactNode;
  variant?: 'standard' | 'compact';
};

export const FetchFailureMessage: React.FC<Props> = ({
  retryFn,
  messageBody,
  variant = 'standard',
}) => {
  if (variant === 'compact')
    return (
      <Alert
        severity="error"
        variant="outlined"
        action={
          retryFn ? (
            <Button
              color="inherit"
              size="small"
              variant={ButtonVariant.text}
              onClick={retryFn}
            >
              Retry
            </Button>
          ) : null
        }
      >
        {messageBody ?? 'Oops! There was a problem loading.'}
      </Alert>
    );

  return (
    <Box display="flex" flexDirection="column" alignItems="center" m={2} mt={5}>
      <Typography align="center" variant="h4">
        Oops! There is a problem.
      </Typography>
      <Typography align="center">
        {messageBody ?? (
          <>
            It's not you - it's us! We have just been alerted to the problem and
            are working on fixing it. Please give us a call at{' '}
            <a href="tel:+18005601469">(800) 560-1469</a> with any questions.
          </>
        )}
      </Typography>
      {isNotNil(retryFn) && (
        <Box mt={2}>
          <Button color="primary" onClick={retryFn}>
            Retry
          </Button>
        </Box>
      )}
    </Box>
  );
};
